// import React, { useEffect, useState } from "react";
// import { getFilteredSessions, getChapterTopic, addContentUsageLog } from "../../lib/LiveclassContent";
// import { getSubjectsByclassId } from "../../lib/ClassApi";
// //import { getSubjectsByClass } from "../../lib/Subscription";
// import { useNavigate, useLocation } from "react-router-dom";
// import { getContentsByTopicID } from "../../lib/LiveclassContent";
// //import { getStudentDetails } from "../../lib/AuthApi";
// import { getTestByTestId } from "../../lib/McqApi";
// //import { readSmartClassXML } from "../../lib/readSmartClassXML";
// //import PlayerPage from "../../pages/player/PlayerPage"
// import { useAuth } from "../../context/AuthProvider";

// export default function PastSessions() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [filters, setFilters] = useState({
//     classId: "",
//     subject: "",
//     chapter: "",
//     topic: "",
//     date: "",
//   });
//   //const [selectedSessionId, setSelectedSessionId] = useState(null);
//   const [selectedType, setSelectedType] = useState(null);
//   const [selectedSession, setSelectedSession] = useState(null);
//   const [topicContents, setTopicContents] = useState([]);
//   const [contentLoading, setContentLoading] = useState(false);
//   const [sessions, setSessions] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [classList, setClassList] = useState([]);
//   const [subjectsList, setSubjectsList] = useState([]);
//   const [chapterList, setChapterList] = useState([]);

//   const { user } = useAuth();

//   const role = user?.role?.toLowerCase();

//   const isStudent = role === "student";

//   const isTeacher = role === "teacher";

//   //const isAdmin = role === "admin";

//   // ================= GET CLASS =================
//   // useEffect(() => {
//   //   const fetchClasses = async () => {
//   //     try {
//   //       const res = await getStudentDetails();

//   //       const student = res?.[0];

//   //       if (student?.UserClasses) {
//   //         setClassList(student.UserClasses);
//   //       }
//   //     } catch (err) {
//   //       console.error(err);
//   //     }
//   //   };

//   //   fetchClasses();
//   // }, []);
//   // ================= GET CLASS FROM LOCAL STORAGE =================
//   useEffect(() => {

//     const storedUser = localStorage.getItem("user");

//     if (storedUser) {

//       const userData = JSON.parse(storedUser);

//       // if (userData?.UserClasses) {

//       //   setClassList(userData.UserClasses);

//       //   // AUTO SELECT FIRST CLASS
//       //   if (userData.UserClasses.length > 0) {

//       //     setFilters((prev) => ({
//       //       ...prev,
//       //       classId: userData.UserClasses[0].ClassId,
//       //     }));

//       //   }
//       // }

//       if (isStudent && userData?.UserClasses) {

//         setClassList(userData.UserClasses);

//         if (userData.UserClasses.length > 0) {

//           setFilters((prev) => ({
//             ...prev,
//             classId: userData.UserClasses[0].ClassId,
//           }));

//         }
//       }

//       // ================= TEACHER =================

//       if (isTeacher && userData?.UserClasses) {

//         console.log("TEACHER CLASSES:", userData.UserClasses);

//         setClassList(userData.UserClasses);

//         if (userData.UserClasses.length > 0) {

//           setFilters((prev) => ({
//             ...prev,
//             classId: userData.UserClasses[0].ClassId,
//           }));

//         }
//       }
//     }

//   }, []);
//   useEffect(() => {

//     if (location.state?.returnState) {

//       const savedState = location.state.returnState;

//       setSelectedSession(savedState.selectedSession || null);

//       setTopicContents(savedState.topicContents || []);

//       setFilters(savedState.filters || {
//         classId: "",
//         subject: "",
//         chapter: "",
//         topic: "",
//         date: "",
//       });

//       setSessions(savedState.sessions || []);

//     }

//   }, [location.state]);
//   // ================= GET SUBJECT =================
//   useEffect(() => {
//     if (filters.classId) {
//       fetchSubjects(filters.classId);
//     } else {
//       setSubjectsList([]);
//     }
//   }, [filters.classId]);

//   const fetchSubjects = async (classId) => {
//     try {
//       const res = await getSubjectsByclassId(classId);

//       if (res.success) {
//         setSubjectsList(res.data);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // ================= GET CHAPTER/TOPIC =================
//   useEffect(() => {
//     if (filters.classId && filters.subject) {
//       fetchChapterTopic(filters.classId, filters.subject);
//     } else {
//       setChapterList([]);
//     }
//   }, [filters.classId, filters.subject]);

//   const fetchChapterTopic = async (classId, subjectId) => {
//     try {
//       const res = await getChapterTopic({
//         classId,
//         subjectId,
//       });

//       if (res.success) {
//         setChapterList(res.data);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // ================= FETCH SESSIONS =================
//   const fetchSessions = async () => {
//     setLoading(true);

//     try {
//       const data = localStorage.getItem("user");
//       const user = data ? JSON.parse(data) : {};

//       // The school must come from the authenticated user's profile. Do not
//       // fall back to School_Id.json here because that value is environment-wide.
//       const schoolId =
//         user?.schoolId ??
//         user?.SchoolId ??
//         user?.schoolID ??
//         user?.SchoolID;

//       const res = await getFilteredSessions(
//         filters,
//         user?.uuid || user?.id,
//         schoolId
//       );

//       const formatted = (res?.liveClass || []).map((item, index) => ({
//         id: item.id || index + 1,
//         sessionTitle: `Session ${index + 1}`,
//         startTime: item.starttime || "--",
//         endTime: item.endtime || "--",
//         subject: item.subjectName,
//         chapter: item.chapterName,
//         topic: item.topicName,
//         teacher: item.teacherName,
//         class: item.id,
//         topicId: item.topicId,
//         teacher: item.teacherName || item.teacherEmail || "-",
//         recordedVideoUrl: item.recordedVideoUrl,
//         notesUrl: item.notesUrl,
//         testUrl: item.testUrl,
//       }));

//       setSessions(formatted);
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   //=============handle view details==================
//   const handleViewDetails = async (session) => {
//     try {

//       setSelectedSession(session);
//       setContentLoading(true);

//       const res = await getContentsByTopicID(session.topicId);

//       console.log("FULL RESPONSE:", res);

//       // if res is array
//       console.log("FIRST PLAY URL:", res?.[0]?.playUrl);

//       // print all play urls
//       res?.forEach((item, index) => {
//         console.log(`Play URL ${index}:`, item.playUrl);
//       });

//       setTopicContents(res || []);
//       // const liveOnly = (res || []).filter(
//       //   item => item.islive === true
//       // );

//       // setTopicContents(liveOnly);

//     } catch (err) {

//       console.error(err);

//     } finally {

//       setContentLoading(false);

//     }
//   };

//   //==============Contentlog uses=================

//   const createUsageLog = async (content) => {

//     const storedUser =
//       JSON.parse(localStorage.getItem("user"));

//     const payload = {
//       ID: null,

//       UserID: String(
//         storedUser?.uuid ||
//         storedUser?.id ||
//         ""
//       ),

//       resourceid: String(
//         content?.contentid || 0
//       ),

//       ResourceType:
//         content?.mediatype || "mp4",

//       UsageID: String(
//         storedUser?.uuid ||
//         storedUser?.id ||
//         ""
//       ),

//       ClassID:
//         Number(filters.classId) || 0,

//       SubjectID:
//         Number(filters.subject) || 0,

//       Section: "",

//       ViewMode: "offline",

//       bookid:
//         Number(content?.bookid) || 0,

//       chapterid:
//         Number(content?.chapterid) || 0,

//       topicid:
//         Number(selectedSession?.topicId) || 0,

//       contentid:
//         Number(content?.contentid) || 0,

//       Usedby:
//         storedUser?.email || "",

//       Username:
//         storedUser?.firstName || "",

//       schoolid:
//         Number(storedUser?.schoolId) || 0,

//       startTime: new Date(),

//       endTime: null
//     };

//     console.log("LOG PAYLOAD", payload);

//     return await addContentUsageLog(payload);
//   };


//   // ================= FILTER CHANGE =================
//   const handleChange = (key, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };


//   //===============Group Content type================
//   // const groupedContents = topicContents.reduce((acc, item) => {
//   //   console.log("=====Content url returned by api======", topicContents.playUrl);
//   //   const type = item.mediatype?.toLowerCase();

//   //   if (!acc[type]) {
//   //     acc[type] = [];
//   //   }

//   //   acc[type].push(item);

//   //   return acc;

//   // }, {});

//   const groupedContents = topicContents.reduce((acc, item) => {

//     let type = item.mediatype?.toLowerCase();

//     if (type === "video") type = "mp4";
//     if (type === "test") type = "mcq";
//     if (type === "note") type = "pdf";

//     if (!acc[type]) {
//       acc[type] = [];
//     }

//     acc[type].push(item);

//     return acc;

//   }, {});




//   return (
//     <div className="p-4">

//       {/* ================= FILTER SECTION ================= */}
//       {(isStudent || isTeacher) && (
//         <div className="bg-white shadow rounded-xl p-4 mb-6">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

//             {/* CLASS */}
//             <select
//               value={filters.classId}
//               onChange={(e) => handleChange("classId", e.target.value)}
//               className="border rounded-lg px-3 py-2"
//             >
//               <option value="">Select Class</option>

//               {/* {classList.map((cls) => (
//                 <option key={cls.ClassId} value={cls.ClassId}>
//                   {cls.classname}
//                 </option>
//               ))} */}

//               {classList.map((cls, index) => (
//                 <option
//                   key={cls.ClassId || cls.classId || index}
//                   value={cls.ClassId || cls.classId}
//                 >
//                   {cls.classname || cls.className}
//                 </option>
//               ))}
//             </select>

//             {/* SUBJECT */}
//             <select
//               value={filters.subject}
//               onChange={(e) => handleChange("subject", e.target.value)}
//               disabled={!filters.classId}
//               className="border rounded-lg px-3 py-2"
//             >
//               <option value="">All Subject</option>

//               {subjectsList.map((sub) => (
//                 <option key={sub.subjectId} value={sub.subjectId}>
//                   {sub.subjectName}
//                 </option>
//               ))}
//             </select>

//             {/* CHAPTER */}
//             <select
//               value={filters.chapter}
//               onChange={(e) => handleChange("chapter", e.target.value)}
//               disabled={!filters.subject}
//               className="border rounded-lg px-3 py-2"
//             >
//               <option value="">All Chapter</option>

//               {chapterList.map((ch) => (
//                 <option key={ch.chapterId} value={ch.chapterId}>
//                   {ch.chapterName}
//                 </option>
//               ))}
//             </select>

//             {/* TOPIC */}
//             <select
//               value={filters.topic}
//               onChange={(e) => handleChange("topic", e.target.value)}
//               disabled={!filters.chapter}
//               className="border rounded-lg px-3 py-2"
//             >
//               <option value="">All Topic</option>

//               {chapterList
//                 .find((ch) => ch.chapterId == filters.chapter)
//                 ?.topics?.map((t) => (
//                   <option key={t.topicid} value={t.topicid}>
//                     {t.topicname}
//                   </option>
//                 ))}
//             </select>

//             {/* DATE */}
//             <input
//               type="date"
//               value={filters.date}
//               onChange={(e) => handleChange("date", e.target.value)}
//               className="border rounded-lg px-3 py-2"
//             />

//             {/* BUTTON */}
//             <button
//               onClick={fetchSessions}
//               className="bg-[#3f35c7] hovbg-[#3428d7] text-white rounded-lg px-4 py-2"
//             >
//               Apply Filter
//             </button>

//           </div>
//         </div>
//       )}

//       {/* ================= LOADING ================= */}
//       {loading && (
//         <div className="text-center mt-10">
//           Loading...
//         </div>
//       )}

//       {/* ================= NO DATA ================= */}
//       {!loading && sessions.length === 0 && (
//         <div className="text-center mt-10 text-gray-500">
//           No Past Sessions Found
//         </div>
//       )}

//       {/* ================= SESSION CARDS =================   {!loading && sessions.length > 0 && (*/}
//       {/* SESSION CARDS */}
//       {!loading &&
//         sessions.length > 0 &&
//         !selectedSession && (
//           <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

//             {sessions.map((session) => (
//               <div
//                 key={session.id}
//                 className="bg-white rounded-xl shadow border overflow-hidden"
//               >

//                 {/* HEADER */}
//                 <div className="bg-gray-200 px-4 py-3 flex justify-between items-center">
//                   <h2 className="font-semibold text-lg">
//                     {session.sessionTitle}
//                   </h2>

//                   <span className="text-sm font-medium">
//                     {session.startTime}
//                   </span>
//                 </div>

//                 {/* BODY */}
//                 <div className="p-4 space-y-4">

//                   {/* <div>
//                   <span className="font-semibold">Time : </span>
//                   {session.startTime} - {session.endTime}
//                 </div> */}

//                   <div>
//                     <span className="font-semibold">Subject : </span>
//                     {session.subject}
//                   </div>

//                   <div>
//                     <span className="font-semibold">Chapter : </span>
//                     {session.chapter}
//                   </div>

//                   <div>
//                     <span className="font-semibold">Topic : </span>
//                     {session.topic}
//                   </div>

//                   <div>
//                     <span className="font-semibold">Teacher : </span>
//                     {session.teacher}
//                   </div>

//                   {/* RECORDING BUTTON */}
//                   <button
//                     disabled={!session.recordedVideoUrl}
//                     onClick={() =>
//                       navigate("/player", {
//                         state: {
//                           url: `baseURL${session.recordedVideoUrl}`,
//                         },
//                       })
//                     }
//                     className={`w-full py-2 rounded-lg text-white ${session.recordedVideoUrl
//                       ? "bg-purple-600 hover:bg-purple-700"
//                       : "bg-gray-400 cursor-not-allowed"
//                       }`}
//                   >
//                     View Recording
//                   </button>
//                   {/*View Details Button */}

//                   <button
//                     onClick={() => handleViewDetails(session)}
//                     className="w-full py-2 rounded-lg border border-purple-600 text-purple-600 hover:bg-purple-50"
//                   >
//                     View Details
//                   </button>
//                 </div>

//               </div>
//             ))}

//           </div>
//         )}

//       {/* ================= CONTENT SCREEN ================= */}

//       {selectedSession && (
//         <div className="bg-white rounded-2xl shadow border p-6">

//           {/* HEADER */}
//           <div className="flex justify-between items-center mb-6">

//             <div>
//               <h2 className="text-2xl font-bold text-purple-700">
//                 {selectedSession.topic}
//               </h2>

//               <p className="text-gray-500 mt-1">
//                 {selectedSession.subject} • {selectedSession.chapter}
//               </p>
//             </div>

//             <button

//               onClick={() => {
//                 setSelectedSession(null);
//                 setTopicContents([]);
//                 setSelectedType(null);
//               }}

//               className="border border-purple-600 text-purple-600 px-4 py-2 rounded-lg hover:bg-purple-50"
//             >
//               Back
//             </button>

//           </div>

//           {/* LOADING */}
//           {contentLoading ? (
//             <div className="text-center py-10">
//               Loading contents...
//             </div>
//           ) : topicContents.length === 0 ? (
//             <div className="text-center py-10 text-gray-400">
//               No content available
//             </div>
//           ) : (
//             <>
//               {/* ================= CONTENT DROPDOWN SECTION ================= */}

//               <div className="space-y-5">

//                 {/* ================= VIDEOS ================= */}
//                 {(groupedContents["mp4"] || []).length > 0 && (

//                   <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

//                     <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-purple-50">

//                       <div>

//                         <h2 className="text-xl font-bold text-purple-700">
//                           🎥 Class Recording
//                         </h2>

//                         <p className="text-sm text-gray-500">
//                           {(groupedContents["mp4"] || []).length} Videos Available
//                         </p>

//                       </div>

//                       <span className="text-purple-700 text-xl">
//                         ▼
//                       </span>

//                     </summary>

//                     <div className="p-4 space-y-3">

//                       {(groupedContents["mp4"] || []).map((content, index) => (

//                         <div
//                           key={content.contentid}
//                           // onClick={() =>
//                           //   navigate("/player", {
//                           //     state: {
//                           //       url: content.playUrl,
//                           //       //url: "https://devstreaming-cdn.apple.com/videos/streaming/examples/adv_dv_atmos/main.m3u8",
//                           //     },
//                           //   })
//                           //}

//                           // onClick={() =>
//                           //   navigate("/player", {
//                           //     state: {
//                           //       url: content.playUrl,

//                           //       returnState: {
//                           //         selectedSession,
//                           //         topicContents,
//                           //         filters,
//                           //         sessions,
//                           //       },
//                           //     },
//                           //   })
//                           // }

//                           onClick={async () => {

//                             const log =
//                               await createUsageLog(content);

//                             navigate("/player", {
//                               state: {
//                                 url: content.playUrl,

//                                 usageLogId:
//                                   log.id || log.Id,

//                                 returnState: {
//                                   selectedSession,
//                                   topicContents,
//                                   filters,
//                                   sessions,
//                                 },
//                               },
//                             });

//                           }}



//                           className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-purple-50 transition"
//                         >

//                           <div className="flex items-center gap-3">

//                             <span className="text-purple-700 font-semibold">
//                               🎥
//                             </span>

//                             <span className="font-medium text-gray-700">
//                               {content.displayname || `Video ${index + 1}`}
//                             </span>

//                           </div>

//                           <span className="text-sm text-purple-600 font-semibold">
//                             Play
//                           </span>

//                         </div>

//                       ))}

//                     </div>

//                   </details>

//                 )}

//                 {/* ================= PDF NOTES ================= */}
//                 {(groupedContents["pdf"] || []).length > 0 && (

//                   <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

//                     <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-blue-50">

//                       <div>

//                         <h2 className="text-xl font-bold text-blue-700">
//                           📄 Class Notes
//                         </h2>

//                         <p className="text-sm text-gray-500">
//                           {(groupedContents["pdf"] || []).length} Notes Available
//                         </p>

//                       </div>

//                       <span className="text-blue-700 text-xl">
//                         ▼
//                       </span>

//                     </summary>

//                     <div className="p-4 space-y-3">

//                       {(groupedContents["pdf"] || []).map((content, index) => (

//                         <div
//                           key={content.contentid}
//                           // onClick={() =>
//                           //   window.open(content.playUrl, "_blank")
//                           // }

//                           onClick={async () => {

//                             await createUsageLog(content);

//                             window.open(
//                               content.playUrl,
//                               "_blank"
//                             );

//                           }}
//                           className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-blue-50 transition"
//                         >

//                           <div className="flex items-center gap-3">

//                             <span className="text-blue-700 font-semibold">
//                               📄
//                             </span>

//                             <span className="font-medium text-gray-700">
//                               {content.displayname || `Notes ${index + 1}`}
//                             </span>

//                           </div>

//                           <span className="text-sm text-blue-600 font-semibold">
//                             Open
//                           </span>

//                         </div>

//                       ))}

//                     </div>

//                   </details>

//                 )}

//                 {/* ================= HTML CONTENT ================= */}
//                 {(groupedContents["html"] || []).length > 0 && (

//                   <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

//                     <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-green-50">

//                       <div>

//                         <h2 className="text-xl font-bold text-green-700">
//                           📝 Curated Content
//                         </h2>

//                         <p className="text-sm text-gray-500">
//                           {(groupedContents["html"] || []).length} Contents Available
//                         </p>

//                       </div>

//                       <span className="text-green-700 text-xl">
//                         ▼
//                       </span>

//                     </summary>

//                     <div className="p-4 space-y-3">

//                       {(groupedContents["html"] || []).map((content, index) => (

//                         <div
//                           key={content.contentid}
//                           // onClick={() =>
//                           //   window.open(content.playUrl, "_blank")
//                           // }
//                           onClick={async () => {

//                             await createUsageLog(content);

//                             window.open(
//                               content.playUrl,
//                               "_blank"
//                             );

//                           }}


//                           className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-green-50 transition"
//                         >

//                           <div className="flex items-center gap-3">

//                             <span className="text-green-700 font-semibold">
//                               📝
//                             </span>

//                             <span className="font-medium text-gray-700">
//                               {content.displayname || `Content ${index + 1}`}
//                             </span>

//                           </div>

//                           <span className="text-sm text-green-600 font-semibold">
//                             Open
//                           </span>

//                         </div>

//                       ))}

//                     </div>

//                   </details>

//                 )}


//                 {/* ================= TEST / MCQ ================= */}
//                 {(groupedContents["mcq"] || []).length > 0 && (

//                   <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

//                     <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-orange-50">

//                       <div>

//                         <h2 className="text-xl font-bold text-orange-600">
//                           ❓ Tests
//                         </h2>

//                         <p className="text-sm text-gray-500">
//                           {(groupedContents["mcq"] || []).length} Tests Available
//                         </p>

//                       </div>

//                       <span className="text-orange-600 text-xl">
//                         ▼
//                       </span>

//                     </summary>

//                     <div className="p-4 space-y-3">

//                       {(groupedContents["mcq"] || []).map((content, index) => (

//                         <div
//                           key={content.contentid}
//                           onClick={async () => {

//                             try {

//                               console.log("CONTENT:", content);

//                               // TEMP STATIC TEST ID
//                               const testId =
//                                 content.contentid

//                               setContentLoading(true);

//                               // const testResponse =
//                               //   await getTestByTestId(testId);

//                               // console.log(
//                               //   "TEST RESPONSE:",
//                               //   testResponse
//                               // );

//                               // // navigate("/player", {
//                               // //   state: {
//                               // //     type: "mcq",
//                               // //     testData: testResponse,
//                               // //   },
//                               // // });

//                               // navigate("/player", {
//                               //   state: {
//                               //     type: "mcq",
//                               //     testData: testResponse,

//                               //     returnState: {
//                               //       selectedSession,
//                               //       topicContents,
//                               //       filters,
//                               //       sessions,
//                               //     },
//                               //   },
//                               // });

//                               const log =
//                                 await createUsageLog(content);

//                               const testResponse =
//                                 await getTestByTestId(testId);

//                               navigate("/player", {
//                                 state: {
//                                   type: "mcq",

//                                   testData:
//                                     testResponse,

//                                   usageLogId:
//                                     log.id || log.Id,

//                                   returnState: {
//                                     selectedSession,
//                                     topicContents,
//                                     filters,
//                                     sessions,
//                                   },
//                                 },
//                               });




//                             } catch (err) {

//                               console.error(err);

//                             } finally {

//                               setContentLoading(false);

//                             }

//                           }}
//                           className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-orange-50 transition"
//                         >

//                           <div className="flex items-center gap-3">

//                             <span className="text-orange-600 font-semibold">
//                               ❓
//                             </span>

//                             <span className="font-medium text-gray-700">
//                               {content.displayname || `Test ${index + 1}`}
//                             </span>

//                           </div>

//                           <span className="text-sm text-orange-600 font-semibold">
//                             Start
//                           </span>

//                         </div>

//                       ))}

//                     </div>

//                   </details>

//                 )}

//               </div>
//             </>

//           )}
//         </div>
//       )
//       }
//     </div >
//   );
// }



import React, { useEffect, useState } from "react";
import {
  getFilteredSessions,
  getChapterTopicBySchool,
  addContentUsageLog,
} from "../../lib/LiveclassContent";
import { getSubjectsByclassId } from "../../lib/ClassApi";
import { useNavigate, useLocation } from "react-router-dom";
import { getContentsByTopicID } from "../../lib/LiveclassContent";
import { getTestByTestId } from "../../lib/McqApi";
import { useAuth } from "../../context/AuthProvider";

export default function PastSessions() {
  const navigate = useNavigate();
  const location = useLocation();

  const [filters, setFilters] = useState({
    classId: "",
    subject: "",
    chapter: "",
    topic: "",
    date: "",
  });

  const [selectedType, setSelectedType] = useState(null);
  const [selectedSession, setSelectedSession] = useState(null);
  const [topicContents, setTopicContents] = useState([]);
  const [contentLoading, setContentLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [classList, setClassList] = useState([]);
  const [subjectsList, setSubjectsList] = useState([]);
  const [chapterList, setChapterList] = useState([]);

  const { user } = useAuth();

  const role = user?.role?.toLowerCase();

  const isStudent = role === "student";
  const isTeacher = role === "teacher";

  // ================= GET CLASS FROM LOCAL STORAGE =================

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      const userData = JSON.parse(storedUser);

      // ================= STUDENT =================

      if (isStudent && userData?.UserClasses) {
        setClassList(userData.UserClasses);

        if (userData.UserClasses.length > 0) {
          setFilters((prev) => ({
            ...prev,
            classId: userData.UserClasses[0].ClassId,
          }));
        }
      }

      // ================= TEACHER =================

      if (isTeacher && userData?.UserClasses) {
        console.log("TEACHER CLASSES:", userData.UserClasses);

        setClassList(userData.UserClasses);

        if (userData.UserClasses.length > 0) {
          setFilters((prev) => ({
            ...prev,
            classId: userData.UserClasses[0].ClassId,
          }));
        }
      }
    }
  }, []);

  // ================= RETURN STATE =================

  useEffect(() => {
    if (location.state?.returnState) {
      const savedState = location.state.returnState;

      setSelectedSession(savedState.selectedSession || null);

      setTopicContents(savedState.topicContents || []);

      setFilters(
        savedState.filters || {
          classId: "",
          subject: "",
          chapter: "",
          topic: "",
          date: "",
        }
      );

      setSessions(savedState.sessions || []);
    }
  }, [location.state]);

  // ================= GET SUBJECT =================

  useEffect(() => {
    if (filters.classId) {
      fetchSubjects(filters.classId);
    } else {
      setSubjectsList([]);
    }
  }, [filters.classId]);

  const fetchSubjects = async (classId) => {
    try {
      const res = await getSubjectsByclassId(classId);

      if (res.success) {
        setSubjectsList(res.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ================= GET CHAPTER/TOPIC =================

  useEffect(() => {
    if (filters.classId && filters.subject) {
      fetchChapterTopic(filters.classId, filters.subject);
    } else {
      setChapterList([]);
    }
  }, [filters.classId, filters.subject]);

  const fetchChapterTopic = async (classId, subjectId) => {
    try {
      const storedUser = JSON.parse(
        localStorage.getItem("user") || "{}"
      );

      const schoolId =
        storedUser?.schoolId ??
        storedUser?.SchoolId ??
        storedUser?.schoolID ??
        storedUser?.SchoolID ??
        localStorage.getItem("schoolId");

      // Previous API:
      // const res = await getChapterTopic({
      //   classId,
      //   subjectId,
      // });
      const res = await getChapterTopicBySchool({
        classId,
        subjectId,
        schoolId,
      });

      if (res.success) {
        setChapterList(res.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ================= FETCH SESSIONS =================

  const fetchSessions = async () => {
    setLoading(true);

    try {
      const data = localStorage.getItem("user");
      const user = data ? JSON.parse(data) : {};

      const schoolId =
        user?.schoolId ??
        user?.SchoolId ??
        user?.schoolID ??
        user?.SchoolID;

      const res = await getFilteredSessions(
        filters,
        user?.uuid || user?.id,
        schoolId
      );

      const formatted = (res?.liveClass || []).map((item, index) => ({
        id: item.id || index + 1,
        sessionTitle: `Session ${index + 1}`,
        startTime: item.starttime || "--",
        endTime: item.endtime || "--",
        subject: item.subjectName,
        chapter: item.chapterName,
        topic: item.topicName,
        teacher: item.teacherName,
        class: item.id,
        topicId: item.topicId,
        teacher: item.teacherName || item.teacherEmail || "-",
        recordedVideoUrl: item.recordedVideoUrl,
        notesUrl: item.notesUrl,
        testUrl: item.testUrl,
      }));

      setSessions(formatted);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  // ================= HANDLE VIEW DETAILS =================

  const handleViewDetails = async (session) => {
    try {
      setSelectedSession(session);
      setContentLoading(true);

      const res = await getContentsByTopicID(session.topicId);

      console.log("FULL RESPONSE:", res);

      console.log("FIRST PLAY URL:", res?.[0]?.playUrl);

      res?.forEach((item, index) => {
        console.log(`Play URL ${index}:`, item.playUrl);
      });

      setTopicContents(res || []);
    } catch (err) {
      console.error(err);
    } finally {
      setContentLoading(false);
    }
  };

  // ================= CONTENT LOG =================

  const createUsageLog = async (content) => {
    const storedUser = JSON.parse(
      localStorage.getItem("user")
    );

    const payload = {
      ID: null,

      UserID: String(
        storedUser?.uuid ||
        storedUser?.id ||
        ""
      ),

      resourceid: String(
        content?.contentid || 0
      ),

      ResourceType:
        content?.mediatype || "mp4",

      UsageID: String(
        storedUser?.uuid ||
        storedUser?.id ||
        ""
      ),

      ClassID:
        Number(filters.classId) || 0,

      SubjectID:
        Number(filters.subject) || 0,

      Section: "",

      ViewMode: "offline",

      bookid:
        Number(content?.bookid) || 0,

      chapterid:
        Number(content?.chapterid) || 0,

      topicid:
        Number(selectedSession?.topicId) || 0,

      contentid:
        Number(content?.contentid) || 0,

      Usedby:
        storedUser?.email || "",

      Username:
        storedUser?.firstName || "",

      schoolid:
        Number(storedUser?.schoolId) || 0,

      startTime: new Date(),

      endTime: null,
    };

    console.log("LOG PAYLOAD", payload);

    return await addContentUsageLog(payload);
  };

  // ================= FILTER CHANGE =================

  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // ================= GROUP CONTENT TYPE =================

  const groupedContents = topicContents.reduce(
    (acc, item) => {
      let type = item.mediatype?.toLowerCase();

      if (type === "video") type = "mp4";
      if (type === "test") type = "mcq";
      if (type === "note") type = "pdf";

      if (!acc[type]) {
        acc[type] = [];
      }

      acc[type].push(item);

      return acc;
    },
    {}
  );

  return (
    <div className="p-4">

      {/* =====================================================
          FILTER SECTION
      ====================================================== */}

      {(isStudent || isTeacher) && (
        <div className="bg-white shadow rounded-xl p-4 mb-6">

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

            {/* CLASS */}

            <select
              value={filters.classId}
              onChange={(e) =>
                handleChange(
                  "classId",
                  e.target.value
                )
              }
              className="
                border
                rounded-lg
                px-3
                py-2
              "
            >
              <option value="">
                Select Class
              </option>

              {classList.map((cls, index) => (
                <option
                  key={
                    cls.ClassId ||
                    cls.classId ||
                    index
                  }
                  value={
                    cls.ClassId ||
                    cls.classId
                  }
                >
                  {cls.classname ||
                    cls.className}
                </option>
              ))}
            </select>


            {/* SUBJECT */}

            <select
              value={filters.subject}
              onChange={(e) =>
                handleChange(
                  "subject",
                  e.target.value
                )
              }
              disabled={!filters.classId}
              className="
                border
                rounded-lg
                px-3
                py-2
              "
            >
              <option value="">
                All Subject
              </option>

              {subjectsList.map((sub) => (
                <option
                  key={sub.subjectId}
                  value={sub.subjectId}
                >
                  {sub.subjectName}
                </option>
              ))}
            </select>


            {/* CHAPTER */}

            <select
              value={filters.chapter}
              onChange={(e) =>
                handleChange(
                  "chapter",
                  e.target.value
                )
              }
              disabled={!filters.subject}
              className="
                border
                rounded-lg
                px-3
                py-2
              "
            >
              <option value="">
                All Chapter
              </option>

              {chapterList.map((ch) => (
                <option
                  key={ch.chapterId}
                  value={ch.chapterId}
                >
                  {ch.chapterName}
                </option>
              ))}
            </select>


            {/* TOPIC */}

            <select
              value={filters.topic}
              onChange={(e) =>
                handleChange(
                  "topic",
                  e.target.value
                )
              }
              disabled={!filters.chapter}
              className="
                border
                rounded-lg
                px-3
                py-2
              "
            >
              <option value="">
                All Topic
              </option>

              {chapterList
                .find(
                  (ch) =>
                    ch.chapterId ==
                    filters.chapter
                )
                ?.topics?.map((t) => (
                  <option
                    key={t.topicid}
                    value={t.topicid}
                  >
                    {t.topicname}
                  </option>
                ))}
            </select>


            {/* DATE */}

            <input
              type="date"
              value={filters.date}
              onChange={(e) =>
                handleChange(
                  "date",
                  e.target.value
                )
              }
              className="
                border
                rounded-lg
                px-3
                py-2
              "
            />


            {/* BUTTON */}

            <button
              onClick={fetchSessions}
              className="
                bg-[#3f35c7]
                hover:bg-[#3428d7]
                text-white
                rounded-lg
                px-4
                py-2
              "
            >
              Apply Filter
            </button>

          </div>
        </div>
      )}


      {/* =====================================================
          LOADING
      ====================================================== */}

      {loading && (
        <div className="text-center mt-10">
          Loading...
        </div>
      )}


      {/* =====================================================
          NO DATA
      ====================================================== */}

      {!loading &&
        sessions.length === 0 && (
          <div className="
            text-center
            mt-10
            text-gray-500
          ">
            No Past Sessions Found
          </div>
        )}


      {/* =====================================================
          SESSION CARDS
      ====================================================== */}

      {!loading &&
        sessions.length > 0 &&
        !selectedSession && (
          <>

            {/* =================================================
                DESKTOP
                3 sessions per row
            ================================================== */}

            <div className="hidden xl:block w-full">

              {Array.from(
                {
                  length:
                    Math.ceil(
                      sessions.length / 3
                    ),
                },
                (_, rowIndex) => {

                  const rowSessions =
                    sessions.slice(
                      rowIndex * 3,
                      rowIndex * 3 + 3
                    );

                  return (
                    <div
                      key={
                        `desktop-row-${rowIndex}`
                      }
                      className={
                        rowIndex > 0
                          ? "mt-8"
                          : ""
                      }
                    >

                      {/* ================= SESSION HEADER ================= */}

                      <div
                        className="
                          grid
                          gap-4
                          mb-3
                        "
                        style={{
                          gridTemplateColumns:
                            `200px repeat(${rowSessions.length}, minmax(0, 1fr))`,
                        }}
                      >

                        {/* Sessions only first row */}

                        <div
                          className={
                            rowIndex === 0
                              ? `
                                min-h-[60px]
                                rounded-xl
                                bg-[#F3EEE2]
                                px-5
                                py-4
                                flex
                                items-center
                                font-semibold
                                text-[#0B1554]
                              `
                              : "min-h-[60px]"
                          }
                        >
                          {rowIndex === 0 &&
                            "Sessions"}
                        </div>


                        {/* Session Headers */}

                        {rowSessions.map(
                          (
                            session,
                            index
                          ) => (
                            <div
                              key={
                                session.id ??
                                `${rowIndex}-${index}`
                              }
                              className="
                                min-h-[60px]
                                rounded-xl
                                border
                                border-[#DDD3C1]
                                bg-[#E8E3E8]
                                px-5
                                py-4
                                flex
                                items-center
                                text-[#3f35c7]
                                font-semibold
                                text-sm
                                xl:text-base
                                break-words
                                min-w-0
                              "
                            >
                              {session.sessionTitle ||
                                `Session ${index + 1
                                }`}
                              {" | "}
                              {session.subject ||
                                ""}
                            </div>
                          )
                        )}

                      </div>


                      {/* ================= DETAILS ================= */}

                      <div
                        className="
                          w-full
                          overflow-hidden
                          rounded-xl
                          border
                          border-[#E4DCCA]
                          bg-[#FAF7EF]
                        "
                      >

                        {/* SUBJECT */}

                        <div
                          className="
                            grid
                            border-b
                            border-[#E4DCCA]
                          "
                          style={{
                            gridTemplateColumns:
                              `200px repeat(${rowSessions.length}, minmax(0, 1fr))`,
                          }}
                        >

                          <div className="
                            px-5
                            py-4
                            font-semibold
                            text-[#0B1554]
                          ">
                            Subject
                          </div>

                          {rowSessions.map(
                            (
                              session,
                              index
                            ) => (
                              <div
                                key={
                                  session.id ??
                                  `subject-${rowIndex}-${index}`
                                }
                                className="
                                  px-5
                                  py-4
                                  text-[#0B1554]
                                  break-words
                                  min-w-0
                                "
                              >
                                {session.subject ||
                                  ""}
                              </div>
                            )
                          )}

                        </div>


                        {/* CHAPTER */}

                        <div
                          className="
                            grid
                            border-b
                            border-[#E4DCCA]
                          "
                          style={{
                            gridTemplateColumns:
                              `200px repeat(${rowSessions.length}, minmax(0, 1fr))`,
                          }}
                        >

                          <div className="
                            px-5
                            py-4
                            font-semibold
                            text-[#0B1554]
                          ">
                            Chapter
                          </div>

                          {rowSessions.map(
                            (
                              session,
                              index
                            ) => (
                              <div
                                key={
                                  session.id ??
                                  `chapter-${rowIndex}-${index}`
                                }
                                className="
                                  px-5
                                  py-4
                                  text-[#0B1554]
                                  break-words
                                  min-w-0
                                "
                              >
                                {session.chapter ||
                                  ""}
                              </div>
                            )
                          )}

                        </div>


                        {/* TOPIC */}

                        <div
                          className="
                            grid
                            border-b
                            border-[#E4DCCA]
                          "
                          style={{
                            gridTemplateColumns:
                              `200px repeat(${rowSessions.length}, minmax(0, 1fr))`,
                          }}
                        >

                          <div className="
                            px-5
                            py-4
                            font-semibold
                            text-[#0B1554]
                          ">
                            Topic
                          </div>

                          {rowSessions.map(
                            (
                              session,
                              index
                            ) => (
                              <div
                                key={
                                  session.id ??
                                  `topic-${rowIndex}-${index}`
                                }
                                className="
                                  px-5
                                  py-4
                                  text-[#0B1554]
                                  break-words
                                  min-w-0
                                "
                              >
                                {session.topic ||
                                  ""}
                              </div>
                            )
                          )}

                        </div>


                        {/* TEACHER */}

                        <div
                          className="grid"
                          style={{
                            gridTemplateColumns:
                              `200px repeat(${rowSessions.length}, minmax(0, 1fr))`,
                          }}
                        >

                          <div className="
                            px-5
                            py-4
                            font-semibold
                            text-[#0B1554]
                          ">
                            Teacher
                          </div>

                          {rowSessions.map(
                            (
                              session,
                              index
                            ) => (
                              <div
                                key={
                                  session.id ??
                                  `teacher-${rowIndex}-${index}`
                                }
                                className="
                                  px-5
                                  py-4
                                  text-[#3f35c7]
                                  flex
                                  items-center
                                  gap-2
                                  flex-wrap
                                  min-w-0
                                "
                              >

                                {session.teacher && (
                                  <>
                                    <span className="
                                      break-words
                                    ">
                                      {
                                        session.teacher
                                      }
                                    </span>

                                    <span className="
                                      inline-flex
                                      items-center
                                      rounded-full
                                      border
                                      border-[#DDD3C1]
                                      px-2.5
                                      py-1
                                      text-xs
                                      text-[#687080]
                                      bg-[#FAF7EF]
                                      shrink-0
                                    ">
                                      ★ 4.9
                                    </span>
                                  </>
                                )}

                              </div>
                            )
                          )}

                        </div>

                      </div>


                      {/* ================= VIEW DETAIL ================= */}

                      <div
                        className="
                          grid
                          mt-3
                        "
                        style={{
                          gridTemplateColumns:
                            `200px repeat(${rowSessions.length}, minmax(0, 1fr))`,
                        }}
                      >

                        <div />

                        {rowSessions.map(
                          (
                            session,
                            index
                          ) => (
                            <div
                              key={
                                session.id ??
                                `button-${rowIndex}-${index}`
                              }
                              className="px-5"
                            >

                              <button
                                type="button"
                                onClick={() =>
                                  handleViewDetails(
                                    session
                                  )
                                }
                                className="
                                  bg-[#D9472F]
                                  hover:bg-[#C83E28]
                                  text-white
                                  font-semibold
                                  rounded-full
                                  px-6
                                  py-2.5
                                  text-sm
                                  xl:text-base
                                  transition
                                "
                              >
                                View detail
                              </button>

                            </div>
                          )
                        )}

                      </div>

                    </div>
                  );
                }
              )}

            </div>


            {/* =================================================
                TABLET
                2 CARDS PER ROW
            ================================================== */}

            <div className="
              hidden
              md:grid
              xl:hidden
              grid-cols-2
              gap-5
              w-full
            ">

              {sessions.map(
                (
                  session,
                  index
                ) => (

                  <div
                    key={
                      session.id ??
                      index
                    }
                    className="
                      w-full
                      min-w-0
                      overflow-hidden
                      rounded-2xl
                      border
                      border-[#E4DCCA]
                      bg-[#FAF7EF]
                    "
                  >

                    {/* HEADER */}

                    <div className="
                      bg-[#E8E3E8]
                      px-5
                      py-4
                      text-[#3f35c7]
                      font-semibold
                      text-lg
                      break-words
                    ">
                      {session.sessionTitle ||
                        `Session ${index + 1
                        }`}
                      {" | "}
                      {session.subject ||
                        ""}
                    </div>


                    {/* SUBJECT */}

                    <div className="
                      px-5
                      py-4
                      border-b
                      border-[#E4DCCA]
                    ">
                      <p className="
                        font-semibold
                        text-[#0B1554]
                      ">
                        Subject
                      </p>

                      {session.subject && (
                        <p className="
                          mt-2
                          text-[#0B1554]
                          break-words
                        ">
                          {session.subject}
                        </p>
                      )}
                    </div>


                    {/* CHAPTER */}

                    <div className="
                      px-5
                      py-4
                      border-b
                      border-[#E4DCCA]
                    ">
                      <p className="
                        font-semibold
                        text-[#0B1554]
                      ">
                        Chapter
                      </p>

                      {session.chapter && (
                        <p className="
                          mt-2
                          text-[#0B1554]
                          break-words
                        ">
                          {session.chapter}
                        </p>
                      )}
                    </div>


                    {/* TOPIC */}

                    <div className="
                      px-5
                      py-4
                      border-b
                      border-[#E4DCCA]
                    ">
                      <p className="
                        font-semibold
                        text-[#0B1554]
                      ">
                        Topic
                      </p>

                      {session.topic && (
                        <p className="
                          mt-2
                          text-[#0B1554]
                          break-words
                        ">
                          {session.topic}
                        </p>
                      )}
                    </div>


                    {/* TEACHER */}

                    <div className="
                      px-5
                      py-4
                    ">

                      <p className="
                        font-semibold
                        text-[#0B1554]
                      ">
                        Teacher
                      </p>

                      {session.teacher && (
                        <div className="
                          mt-2
                          flex
                          items-center
                          gap-2
                          flex-wrap
                        ">

                          <span className="
                            text-[#3f35c7]
                            break-words
                          ">
                            {session.teacher}
                          </span>

                          <span className="
                            inline-flex
                            items-center
                            rounded-full
                            border
                            border-[#DDD3C1]
                            px-2.5
                            py-1
                            text-xs
                            text-[#687080]
                          ">
                            ★ 4.9
                          </span>

                        </div>
                      )}

                    </div>


                    {/* VIEW DETAIL */}

                    <div className="
                      px-5
                      pb-5
                    ">

                      <button
                        type="button"
                        onClick={() =>
                          handleViewDetails(
                            session
                          )
                        }
                        className="
                          bg-[#D9472F]
                          hover:bg-[#C83E28]
                          text-white
                          font-semibold
                          rounded-full
                          px-6
                          py-2.5
                          text-sm
                          w-full
                        "
                      >
                        View detail
                      </button>

                    </div>

                  </div>

                )
              )}

            </div>


            {/* =================================================
                MOBILE
                1 CARD PER ROW
            ================================================== */}

            <div className="
              grid
              md:hidden
              grid-cols-1
              gap-4
              w-full
            ">

              {sessions.map(
                (
                  session,
                  index
                ) => (

                  <div
                    key={
                      session.id ??
                      index
                    }
                    className="
                      w-full
                      min-w-0
                      overflow-hidden
                      rounded-2xl
                      border
                      border-[#E4DCCA]
                      bg-[#FAF7EF]
                    "
                  >

                    {/* MOBILE HEADER */}

                    <div className="
                      bg-[#E8E3E8]
                      px-5
                      py-4
                      text-[#3f35c7]
                      font-semibold
                      text-base
                      break-words
                    ">
                      Session :{" "}
                      {session.sessionTitle ||
                        `Session ${index + 1
                        }`}
                      {" | "}
                      {session.subject ||
                        ""}
                    </div>


                    {/* SUBJECT */}

                    <div className="
                      px-5
                      py-4
                      border-b
                      border-[#E4DCCA]
                    ">

                      <p className="
                        font-semibold
                        text-[#0B1554]
                      ">
                        Subject
                      </p>

                      {session.subject && (
                        <p className="
                          mt-2
                          text-[#0B1554]
                          break-words
                        ">
                          {session.subject}
                        </p>
                      )}

                    </div>


                    {/* CHAPTER */}

                    <div className="
                      px-5
                      py-4
                      border-b
                      border-[#E4DCCA]
                    ">

                      <p className="
                        font-semibold
                        text-[#0B1554]
                      ">
                        Chapter
                      </p>

                      {session.chapter && (
                        <p className="
                          mt-2
                          text-[#0B1554]
                          break-words
                        ">
                          {session.chapter}
                        </p>
                      )}

                    </div>


                    {/* TOPIC */}

                    <div className="
                      px-5
                      py-4
                      border-b
                      border-[#E4DCCA]
                    ">

                      <p className="
                        font-semibold
                        text-[#0B1554]
                      ">
                        Topic
                      </p>

                      {session.topic && (
                        <p className="
                          mt-2
                          text-[#0B1554]
                          break-words
                        ">
                          {session.topic}
                        </p>
                      )}

                    </div>


                    {/* TEACHER */}

                    <div className="
                      px-5
                      py-4
                    ">

                      <p className="
                        font-semibold
                        text-[#0B1554]
                      ">
                        Teacher
                      </p>

                      {session.teacher && (
                        <div className="
                          mt-2
                          flex
                          items-center
                          gap-2
                          flex-wrap
                        ">

                          <span className="
                            text-[#3f35c7]
                            break-words
                          ">
                            {session.teacher}
                          </span>

                          <span className="
                            inline-flex
                            items-center
                            rounded-full
                            border
                            border-[#DDD3C1]
                            px-2.5
                            py-1
                            text-xs
                            text-[#687080]
                          ">
                            ★ 4.9
                          </span>

                        </div>
                      )}

                    </div>


                    {/* VIEW DETAIL */}

                    <div className="
                      px-5
                      pb-5
                    ">

                      <button
                        type="button"
                        onClick={() =>
                          handleViewDetails(
                            session
                          )
                        }
                        className="
                          bg-[#D9472F]
                          hover:bg-[#C83E28]
                          text-white
                          font-semibold
                          rounded-full
                          px-6
                          py-2.5
                          text-sm
                          w-full
                        "
                      >
                        View detail
                      </button>

                    </div>

                  </div>

                )
              )}

            </div>

          </>
        )}


      {/* =====================================================
          CONTENT SCREEN
      ====================================================== */}

      {selectedSession && (
        <div className="
          bg-white
          rounded-2xl
          shadow
          border
          p-6
        ">

          {/* HEADER */}

          <div className="
            flex
            justify-between
            items-center
            mb-6
          ">

            <div>

              <h2 className="
                text-2xl
                font-bold
                text-purple-700
              ">
                {selectedSession.topic}
              </h2>

              <p className="
                text-gray-500
                mt-1
              ">
                {selectedSession.subject}
                {" • "}
                {selectedSession.chapter}
              </p>

            </div>


            <button
              onClick={() => {
                setSelectedSession(null);
                setTopicContents([]);
                setSelectedType(null);
              }}
              className="
                border
                border-purple-600
                text-purple-600
                px-4
                py-2
                rounded-lg
                hover:bg-purple-50
              "
            >
              Back
            </button>

          </div>


          {/* LOADING */}

          {contentLoading ? (
            <div className="
              text-center
              py-10
            ">
              Loading contents...
            </div>
          ) : topicContents.length === 0 ? (
            <div className="
              text-center
              py-10
              text-gray-400
            ">
              No content available
            </div>
          ) : (
            <>

              {/* ================= CONTENT DROPDOWN ================= */}

              <div className="space-y-5">

                {/* ================= VIDEOS ================= */}

                {(groupedContents["mp4"] || [])
                  .length > 0 && (

                    <details className="
                    border
                    rounded-2xl
                    bg-white
                    shadow-sm
                    overflow-hidden
                  ">

                      <summary className="
                      cursor-pointer
                      list-none
                      flex
                      justify-between
                      items-center
                      px-6
                      py-5
                      bg-purple-50
                    ">

                        <div>

                          <h2 className="
                          text-xl
                          font-bold
                          text-purple-700
                        ">
                            🎥 Class Recording
                          </h2>

                          <p className="
                          text-sm
                          text-gray-500
                        ">
                            {
                              (
                                groupedContents[
                                "mp4"
                                ] || []
                              ).length
                            }{" "}
                            Videos Available
                          </p>

                        </div>

                        <span className="
                        text-purple-700
                        text-xl
                      ">
                          ▼
                        </span>

                      </summary>


                      <div className="
                      p-4
                      space-y-3
                    ">

                        {(
                          groupedContents[
                          "mp4"
                          ] || []
                        ).map(
                          (
                            content,
                            index
                          ) => (

                            <div
                              key={
                                content.contentid
                              }
                              onClick={async () => {

                                const log =
                                  await createUsageLog(
                                    content
                                  );

                                navigate(
                                  "/player",
                                  {
                                    state: {
                                      url:
                                        content.playUrl,

                                      usageLogId:
                                        log.id ||
                                        log.Id,

                                      returnState: {
                                        selectedSession,
                                        topicContents,
                                        filters,
                                        sessions,
                                      },
                                    },
                                  }
                                );
                              }}
                              className="
                              flex
                              items-center
                              justify-between
                              border
                              rounded-lg
                              px-4
                              py-3
                              cursor-pointer
                              hover:bg-purple-50
                              transition
                            "
                            >

                              <div className="
                              flex
                              items-center
                              gap-3
                            ">

                                <span className="
                                text-purple-700
                                font-semibold
                              ">
                                  🎥
                                </span>

                                <span className="
                                font-medium
                                text-gray-700
                              ">
                                  {
                                    content.displayname ||
                                    `Video ${index + 1
                                    }`
                                  }
                                </span>

                              </div>

                              <span className="
                              text-sm
                              text-purple-600
                              font-semibold
                            ">
                                Play
                              </span>

                            </div>

                          )
                        )}

                      </div>

                    </details>
                  )}


                {/* ================= PDF NOTES ================= */}

                {(groupedContents["pdf"] || [])
                  .length > 0 && (

                    <details className="
                    border
                    rounded-2xl
                    bg-white
                    shadow-sm
                    overflow-hidden
                  ">

                      <summary className="
                      cursor-pointer
                      list-none
                      flex
                      justify-between
                      items-center
                      px-6
                      py-5
                      bg-blue-50
                    ">

                        <div>

                          <h2 className="
                          text-xl
                          font-bold
                          text-blue-700
                        ">
                            📄 Class Notes
                          </h2>

                          <p className="
                          text-sm
                          text-gray-500
                        ">
                            {
                              (
                                groupedContents[
                                "pdf"
                                ] || []
                              ).length
                            }{" "}
                            Notes Available
                          </p>

                        </div>

                        <span className="
                        text-blue-700
                        text-xl
                      ">
                          ▼
                        </span>

                      </summary>


                      <div className="
                      p-4
                      space-y-3
                    ">

                        {(
                          groupedContents[
                          "pdf"
                          ] || []
                        ).map(
                          (
                            content,
                            index
                          ) => (

                            <div
                              key={
                                content.contentid
                              }
                              onClick={async () => {

                                await createUsageLog(
                                  content
                                );

                                window.open(
                                  content.playUrl,
                                  "_blank"
                                );
                              }}
                              className="
                              flex
                              items-center
                              justify-between
                              border
                              rounded-lg
                              px-4
                              py-3
                              cursor-pointer
                              hover:bg-blue-50
                              transition
                            "
                            >

                              <div className="
                              flex
                              items-center
                              gap-3
                            ">

                                <span className="
                                text-blue-700
                                font-semibold
                              ">
                                  📄
                                </span>

                                <span className="
                                font-medium
                                text-gray-700
                              ">
                                  {
                                    content.displayname ||
                                    `Notes ${index + 1
                                    }`
                                  }
                                </span>

                              </div>

                              <span className="
                              text-sm
                              text-blue-600
                              font-semibold
                            ">
                                Open
                              </span>

                            </div>

                          )
                        )}

                      </div>

                    </details>
                  )}


                {/* ================= HTML CONTENT ================= */}

                {(groupedContents["html"] || [])
                  .length > 0 && (

                    <details className="
                    border
                    rounded-2xl
                    bg-white
                    shadow-sm
                    overflow-hidden
                  ">

                      <summary className="
                      cursor-pointer
                      list-none
                      flex
                      justify-between
                      items-center
                      px-6
                      py-5
                      bg-green-50
                    ">

                        <div>

                          <h2 className="
                          text-xl
                          font-bold
                          text-green-700
                        ">
                            📝 Curated Content
                          </h2>

                          <p className="
                          text-sm
                          text-gray-500
                        ">
                            {
                              (
                                groupedContents[
                                "html"
                                ] || []
                              ).length
                            }{" "}
                            Contents Available
                          </p>

                        </div>

                        <span className="
                        text-green-700
                        text-xl
                      ">
                          ▼
                        </span>

                      </summary>


                      <div className="
                      p-4
                      space-y-3
                    ">

                        {(
                          groupedContents[
                          "html"
                          ] || []
                        ).map(
                          (
                            content,
                            index
                          ) => (

                            <div
                              key={
                                content.contentid
                              }
                              onClick={async () => {

                                await createUsageLog(
                                  content
                                );

                                window.open(
                                  content.playUrl,
                                  "_blank"
                                );
                              }}
                              className="
                              flex
                              items-center
                              justify-between
                              border
                              rounded-lg
                              px-4
                              py-3
                              cursor-pointer
                              hover:bg-green-50
                              transition
                            "
                            >

                              <div className="
                              flex
                              items-center
                              gap-3
                            ">

                                <span className="
                                text-green-700
                                font-semibold
                              ">
                                  📝
                                </span>

                                <span className="
                                font-medium
                                text-gray-700
                              ">
                                  {
                                    content.displayname ||
                                    `Content ${index + 1
                                    }`
                                  }
                                </span>

                              </div>

                              <span className="
                              text-sm
                              text-green-600
                              font-semibold
                            ">
                                Open
                              </span>

                            </div>

                          )
                        )}

                      </div>

                    </details>
                  )}


                {/* ================= TEST / MCQ ================= */}

                {(groupedContents["mcq"] || [])
                  .length > 0 && (

                    <details className="
                    border
                    rounded-2xl
                    bg-white
                    shadow-sm
                    overflow-hidden
                  ">

                      <summary className="
                      cursor-pointer
                      list-none
                      flex
                      justify-between
                      items-center
                      px-6
                      py-5
                      bg-orange-50
                    ">

                        <div>

                          <h2 className="
                          text-xl
                          font-bold
                          text-orange-600
                        ">
                            ❓ Tests
                          </h2>

                          <p className="
                          text-sm
                          text-gray-500
                        ">
                            {
                              (
                                groupedContents[
                                "mcq"
                                ] || []
                              ).length
                            }{" "}
                            Tests Available
                          </p>

                        </div>

                        <span className="
                        text-orange-600
                        text-xl
                      ">
                          ▼
                        </span>

                      </summary>


                      <div className="
                      p-4
                      space-y-3
                    ">

                        {(
                          groupedContents[
                          "mcq"
                          ] || []
                        ).map(
                          (
                            content,
                            index
                          ) => (

                            <div
                              key={
                                content.contentid
                              }
                              onClick={async () => {

                                try {

                                  console.log(
                                    "CONTENT:",
                                    content
                                  );

                                  const testId =
                                    content.contentid;

                                  setContentLoading(
                                    true
                                  );

                                  const log =
                                    await createUsageLog(
                                      content
                                    );

                                  const testResponse =
                                    await getTestByTestId(
                                      testId
                                    );

                                  navigate(
                                    "/player",
                                    {
                                      state: {
                                        type: "mcq",

                                        testData:
                                          testResponse,

                                        usageLogId:
                                          log.id ||
                                          log.Id,

                                        returnState: {
                                          selectedSession,
                                          topicContents,
                                          filters,
                                          sessions,
                                        },
                                      },
                                    }
                                  );

                                } catch (err) {

                                  console.error(
                                    err
                                  );

                                } finally {

                                  setContentLoading(
                                    false
                                  );

                                }

                              }}
                              className="
                              flex
                              items-center
                              justify-between
                              border
                              rounded-lg
                              px-4
                              py-3
                              cursor-pointer
                              hover:bg-orange-50
                              transition
                            "
                            >

                              <div className="
                              flex
                              items-center
                              gap-3
                            ">

                                <span className="
                                text-orange-600
                                font-semibold
                              ">
                                  ❓
                                </span>

                                <span className="
                                font-medium
                                text-gray-700
                              ">
                                  {
                                    content.displayname ||
                                    `Test ${index + 1
                                    }`
                                  }
                                </span>

                              </div>

                              <span className="
                              text-sm
                              text-orange-600
                              font-semibold
                            ">
                                Start
                              </span>

                            </div>

                          )
                        )}

                      </div>

                    </details>
                  )}

              </div>

            </>
          )}

        </div>
      )}

    </div>
  );
}









